// c_zeta-viewed.js — 閲覧履歴の記録（2-7）。商品ページのZETAスナップショット(#c_zeta-viewed-current)をlocalStorage(c_zeta_viewed)へ保存。表示はc_zeta-recently-viewedセクション。

(function () {
  'use strict';

  const KEY = 'c_zeta_viewed';
  const MAX = 20; // 保持上限（表示件数はセクション側で絞る）

  const node = document.getElementById('c_zeta-viewed-current');
  if (!node) return;

  let snapshot;
  try {
    snapshot = JSON.parse(node.textContent);
  } catch (_) {
    return;
  }
  if (!snapshot || !snapshot.id) return;

  // money_without_currency由来の文字列("9,900")を数値化（ZETAカードは数値前提）
  const toNumber = (v) => {
    if (v === null || v === undefined || v === '') return null;
    if (typeof v === 'number') return v;
    const digits = String(v).replace(/[^\d]/g, '');
    return digits === '' ? null : parseInt(digits, 10);
  };
  if (Array.isArray(snapshot.variants)) {
    snapshot.variants.forEach((variant) => {
      variant.regular_price = toNumber(variant.regular_price);
      variant.sale_price = toNumber(variant.sale_price);
    });
  }

  try {
    const raw = localStorage.getItem(KEY);
    const list = (raw ? JSON.parse(raw) : []).filter((it) => it && it.id && it.id !== snapshot.id);
    list.unshift(snapshot); // 直近閲覧を先頭へ
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch (_) {
    // localStorage不可（プライベートブラウジング等）は保存しない
  }
})();
